import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=f4852fd2&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"
import style0 from "./Blog.vue?vue&type=style&index=0&id=f4852fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4852fd2",
  null
  
)

export default component.exports